import { render, staticRenderFns } from "./FlowBacklog.vue?vue&type=template&id=6ec348ad&"
import script from "./FlowBacklog.vue?vue&type=script&lang=js&"
export * from "./FlowBacklog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports